import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f4400f"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 1,
  class: "hd-content-image__placeholder placeholder"
}
const _hoisted_3 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["hd-content-image", `hd-content-image__${_ctx.endpointId}`])
  }, [
    (_ctx.imageSource)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.imageSource
        }, null, 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_lyra_asset, { "asset-key": "app-template-image-not-found" })
        ])),
    (_ctx.$lye(_ctx.captionKey))
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "hd-content-image__caption",
          innerHTML: _ctx.$ly(_ctx.captionKey)
        }, null, 8, _hoisted_3))
      : _createCommentVNode("", true)
  ], 2))
}